export const LOGIN_URL = "https://miketmapi.mikelegal.com/api";
export const ROOT_URL = `${LOGIN_URL}/iris`;
